import template from "./quote-editor-page.html";

const QuoteEditorPageComponent = {
  bindings: {
    quote: "<",
  },
  template: template,
  controller: class QuoteEditorPageController {
    /* @ngInject */
    constructor($rootScope, $state, $stateParams, Quote, Utils, SweetAlertService, quoteLanguages) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.Quote = Quote;
      this.Utils = Utils;
      this.SweetAlertService = SweetAlertService;
      this.quoteLanguages = quoteLanguages;
    }

    $onInit() {
      this.quoteLanguageResource = this.quoteLanguages.find(
        (quoteLanguage) => quoteLanguage.code === this.quote.language,
      );
      this.version = this.$state.params.version || this.quote.lastVersion.number;
      this.saving = false;

      this.SweetAlertService.loadingQuoteEditor();
      this.$rootScope.$watchCollection(
        () => this.$state.params,
        (newValue) => {
          this.version = newValue.version || this.quote.lastVersion.number;
        },
      );
    }

    areRatesUpdated() {
      let ratesUpdated = true;
      const versionRatesDate = new Date(this.quote.lastVersion.exchangeInfo.date);
      const lastAvailableRatesDate = new Date(this.$rootScope.organization.exchangeRates.date);

      if (versionRatesDate < lastAvailableRatesDate) ratesUpdated = false;
      return ratesUpdated;
    }

    existCostWithDifferentCurrency() {
      const quoteSections = this.quote.lastVersion.sections;
      let costWithDifferentCurrency = false;

      quoteSections.forEach((quoteSection) => {
        if (quoteSection.sectionType === "pricingTable") {
          const quoteLines = quoteSection.pricingTable.lines;

          quoteLines.forEach((line) => {
            line.costs.forEach((cost) => {
              if (cost.currency !== this.quote.lastVersion.currency) costWithDifferentCurrency = true;
            });
          });
        }
      });

      return costWithDifferentCurrency;
    }

    async updateRates() {
      const costCurrencies = this._generateCurrencyCostsArray();
      const costCurrenciesFormatted = costCurrencies.join(", ");
      const ratiosTable = this._generateRatiosTable(costCurrencies);

      const updateMode = await this.SweetAlertService.howUpdateQuote(costCurrenciesFormatted, ratiosTable);

      if (!updateMode) return;

      this.quote.lastVersion.setExchangeInfo(this.$rootScope.organization.exchangeRates);

      await this.quote.updateHeader();
      this.quote.lastVersion.sections.forEach((section) => {
        if (section.sectionType === "pricingTable") {
          section.pricingTable.lines.forEach((line) => {
            if (updateMode === "keep-price") line.updateMargin(this.$rootScope.organization.exchangeRates.rates);
            else if (updateMode === "keep-margin") line.updatePrice(this.$rootScope.organization.exchangeRates.rates);
          });
        }
      });
      await this.quote.updateSections();
      this.SweetAlertService.quoteExchangeRatesUpdated();

      this.saving = false;
      this.$rootScope.$applyAsync();
    }

    async refreshQuote() {
      this.$state.reload();
    }

    _generateCurrencyCostsArray() {
      const sections = this.quote.lastVersion.sections;
      const currencyCostArray = [];

      sections.forEach((section) => {
        if (section.sectionType === "pricingTable") {
          section.pricingTable.lines.forEach((line) => {
            line.costs.forEach((cost) => {
              if (
                currencyCostArray.indexOf(cost.currency) === -1 &&
                this.quote.lastVersion.currency !== cost.currency
              ) {
                currencyCostArray.push(cost.currency);
              }
            });
          });
        }
      });

      return currencyCostArray;
    }

    _generateRatiosTable(currencyCostsArray) {
      const currentRates = this.quote.lastVersion.exchangeInfo.rates;
      const currentCurrency = this.quote.lastVersion.currency;
      const todayRates = this.$rootScope.organization.exchangeRates.rates;

      let ratiosTable = `<table class="table m-t-15">
          <thead>
            <tr>
              <th>Tipo de cambio antiguo</th>
              <th>Tipo de cambio nuevo</th>
            </tr>
          </thead>
          <tbody>`;

      currencyCostsArray.forEach((currency) => {
        const oldRate = this.Utils.getCurrencyNumberConvertedRound4(currentRates, currentCurrency, currency, 1);
        const newRate = this.Utils.getCurrencyNumberConvertedRound4(todayRates, currentCurrency, currency, 1);

        ratiosTable += `<tr>
          <td>1 ${currentCurrency} -> ${oldRate} ${currency}</td>
          <td>1 ${currentCurrency} -> ${newRate} ${currency}</td>
        </tr>`;
      });
      ratiosTable += "</tbody></table>";

      return ratiosTable;
    }
  },
};

export default QuoteEditorPageComponent;
